import { useAuthorization } from 'components/Authorization';

export const useYuYiInfo = () => {
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  const isYuYi = payload?.extraOpenPlatform?.includes('YUYI') ?? false;
  return {
    isYuYi,
    url:
      isYuYi && payload?.id
        ? `https://console.vocplus.ai/oauth?app=thirdPlatform&platform=CHATPLUS-AI&platformId=${payload.id}`
        : undefined,
  };
};
